"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPONENT_NAME = void 0;
var COMPONENT_NAME = exports.COMPONENT_NAME = 'Button';